import api from '@/services/utils/apiInstance'

class ProductService {
  async getPaginatedProductList(search, sort, order, page, limit, filters, signal = undefined) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''
    const url =
      '/admin/product/list' +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit +
      '&filters=' +
      filters
    const response = await api.get(url, { signal })
    return response.data
  }

  async exportProducts(search, sort, order, filters) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''
    const url =
      '/admin/product/export' +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&filters=' +
      filters
    const response = await api.get(url, { responseType: 'blob' })
    return response.data
  }

  async getPaginatedSubProductList(productId, page, limit) {
    const url = '/admin/sub-product/list/' + productId + '?page=' + page + '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async createProduct(data) {
    const response = await api.post('/admin/product', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getProduct(productId) {
    const response = await api.get('/admin/product/' + productId)
    return response.data
  }

  async getProductEditContext(productId) {
    const response = await api.get('/admin/product/' + productId + '/edit-context')
    return response.data
  }

  async getProductByBoomerangId(boomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(boomerangId)

    const response = await api.get('/admin/product/by-boomerang-id/' + encodedProductBoomerangId)
    return response.data
  }

  async updateProduct(data, productId) {
    const response = await api.put(`/admin/product/${productId}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getAllProductList(productId, manufacturerId, categoryId, subCategoryId) {
    const queryParams = new URLSearchParams()

    if (Array.isArray(productId)) {
      queryParams.append('exclude_product_id_list', JSON.stringify(productId))
    } else if (productId) {
      queryParams.append('exclude_product_id_list', productId)
    }
    if (manufacturerId) queryParams.append('manufacturer_id', manufacturerId)
    if (categoryId) queryParams.append('category_id', categoryId)
    if (subCategoryId) queryParams.append('sub_category_id', subCategoryId)

    const response = await api.get('/admin/product/all?' + queryParams.toString())

    return response.data
  }

  async addSubProductToProduct(productId, subProductId) {
    const data = {
      parent_id: Number(productId),
      sub_product_id: subProductId
    }
    const response = await api.post('/admin/product/add-sub-product', data)

    return response.data
  }

  async deleteSubProductFromProduct(productId, subProductId) {
    const data = {
      parent_id: productId,
      sub_product_id: subProductId
    }
    const response = await api.post('/admin/product/delete-sub-product', data)

    return response.data
  }

  async getProductListBySubCategory(subCategoryBoomerangId) {
    let encodedSubCategoryBoomerangId = encodeURIComponent(subCategoryBoomerangId)

    const url = '/admin/product/all/by-sub-category/' + encodedSubCategoryBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getSerialNumberPictureBySubCategoryId(subCategoryId) {
    const response = await api.get(
      '/admin/product/serial-number-picture-by-sub-category-id/' + subCategoryId,
      { responseType: 'blob' }
    )
    return response.data
  }
}

export default new ProductService()
